import { TThunkAction } from '../../types/redux';
import { setNewReviewFormStep } from '../../actions/newReview';
import { ENewReviewModalStep } from '../../types/newReview';
import { addReview } from '../../services/reviews/addReview';
import { trackNewReviewSubmit } from '../../analytics/newReview';
import { prepareNewReviewsSecondStepOpen } from '../../mappers/prepareNewReviews/analyticsMapper';
import { getNewbuildingRating } from '../../selectors/newbuildingInfo';
import { getCons, getPros, getUserStatus, getIsAnonymous, getName } from '../../selectors/newReview';
import { getFirstName, getUserForAnalytics } from '../../selectors/user';

export function addReviewActions(): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    try {
      const state = getState();
      const { httpApi, custom } = context;
      const { newbuildingInfo, newReview } = state;
      const user = getUserForAnalytics(state);

      await addReview({
        httpApi,
        parameters: { newbuildingId: newbuildingInfo.newbuildingId, newReview },
      });

      trackNewReviewSubmit({
        siteType: custom.deviceType,
        ratings: prepareNewReviewsSecondStepOpen(newReview),
        rating: getNewbuildingRating(state),
        review_status: getUserStatus(state),
        pros: getPros(state),
        cons: getCons(state),
        is_anonymous: getIsAnonymous(state),
        is_name_entered: !!getName(state) || !!getFirstName(state),
        user,
      });
      dispatch(setNewReviewFormStep(ENewReviewModalStep.Success));
    } catch (e) {
      dispatch(setNewReviewFormStep(ENewReviewModalStep.Error));
    }
  };
}
